import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  DiJavascript1,
  DiReact,
  DiPython,
  DiGit,
  DiJava,
} from "react-icons/di";
import {
  SiAmazonaws,
  SiDocker,
  SiKubernetes,
  SiJenkins,
  SiRedis,
  SiSolidity,
  SiPostgresql,
  SiSpringboot,
  SiLinux,
} from "react-icons/si";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons"><SiAmazonaws title="AWS" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiDocker title="Docker" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiKubernetes title="Kubernetes" /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiJenkins title="Jenkins" /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiJavascript1 /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiReact /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiSolidity /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiGit /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiRedis /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiPostgresql /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiPython /></Col>
      <Col xs={4} md={2} className="tech-icons"><DiJava /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiSpringboot /></Col>
      <Col xs={4} md={2} className="tech-icons"><SiLinux /></Col>
    </Row>
  );
}

export default Techstack;
